import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0ec7806c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7806c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec7806c')) {
      api.createRecord('0ec7806c', component.options)
    } else {
      api.reload('0ec7806c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0ec7806c&scoped=true&", function () {
      api.rerender('0ec7806c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21l0gCnLvYxnO/JS/comp/Accordion.vue"
export default component.exports